import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import React from "react";

export function fixedHeaderContent(attributes) {
    return (
        <TableRow>
            {attributes.map((column) => (
                <TableCell
                    key={column.dataKey}
                    className="btn-txt"
                    variant="head"
                    align={column.align}
                    sx={{backgroundColor: 'background.paper'}}
                    style={{
                        width: column.width,
                        color: "var(--bs-primary)",
                        borderBottom: "1px solid var(--bs-primary)",
                    }}
                >
                    {column.label}
                </TableCell>
            ))}
        </TableRow>
    );
}